import { request } from '@/shared/api/request'

export const getEContract = (externalId) => {
	return request({ url: `colcontract/ecd/get/${externalId}`, method: 'GET' })
}
